import { Typography, Box, Chip, IconButton, Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { Close, OpenInNew, Minimize } from '@material-ui/icons';
import { ChatBotStore } from '../stores/chatBotStore';
import { NewChatConfirmation, SessionFeedbackDialog } from './chatBotDialogs';
import { getOrigin } from '../utils/util';

const useStyles = makeStyles(theme => ({
  container: {
    background: theme.palette.background.paper,
    padding: theme.spacing(2, 4),
    display: 'flex',
    flexDirection: "column",
    justifyContent: 'flex-start',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  buttonsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& .MuiIconButton-root': {
      padding: '5px',
    },
  },
  newChatButton: {
    borderColor: theme.palette.primary.main,
    '&:hover': {
      borderColor: theme.palette.primary.dark,
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
    },
  }
}));

interface ChatBotHeaderProps {
  isFullScreen: boolean;
  botName: string;
  store: ChatBotStore;
}


export const ChatBotHeader = observer(({ isFullScreen, botName, store }: ChatBotHeaderProps) => {
  const classes = useStyles();
  const [openFeedbackDialog, setOpenFeedbackDialog] = useState(false);
  const [openNewChatConfirmModal, setOpenNewChatConfirmModal] = useState(false);

  const redirectToParent = () => {
    const message = { data: 'redirect-chat-bot' };
    window.parent.postMessage(message, getOrigin());
    localStorage.setItem('chatBotSessionId', store.config.sessionId);
  };

  return (
    <>
      <Box className={classes.container}>
        <Box className={classes.header}>
          <Box>
            <Typography variant="h6">{botName}</Typography>
          </Box>
          <Box className={classes.buttonsContainer}>
            <Chip
              label="New Chat"
              variant="outlined"
              className={classes.newChatButton}
              onClick={() => setOpenNewChatConfirmModal(true)}
            />
            <Divider orientation="vertical" flexItem style={{ margin: '0 8px' }} />
            {!isFullScreen && (
              <>
                <IconButton
                  onClick={redirectToParent}
                  title={'Redirect Chatbot'}
                  aria-label={'Redirect Chatbot'}
                  disabled={store.messages[store.messages.length - 1]?.isStreaming && store.loading}
                >
                  <OpenInNew />
                </IconButton>

                <IconButton
                  onClick={store.handleMinimize}
                  title={'Minimize Chatbot'}
                  aria-label={'Minimize Chatbot'}
                >
                  <Minimize />
                </IconButton>
              </>
            )}
            <IconButton
              onClick={() => setOpenFeedbackDialog(true)}
              title={'Close Chatbot'}
              aria-label={'Close Chatbot'}
            >
              <Close />
            </IconButton>
          </Box>
        </Box>
        <Typography variant="body2">AI-powered help</Typography>
      </Box>
      <SessionFeedbackDialog
        open={openFeedbackDialog}
        isFullScreen={isFullScreen}
        store={store}
        handleClose={() => setOpenFeedbackDialog(false)}
      />
      <NewChatConfirmation
        open={openNewChatConfirmModal}
        handleCloseModal={() => setOpenNewChatConfirmModal(false)}
        handleConfirm={() => {
          if (isFullScreen) {
            localStorage.removeItem('chatBotSessionId');
          }
          store.startNewChat();
          setOpenNewChatConfirmModal(false);
        }}
      />
    </>

  );
});
